export class VoteEnvironmentStore {

    public preventViewChangingLinks = false;

}